module.exports = __webpack_public_path__ + "img/invite_title_photo3@2x.ee17f0fd.png";